<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/kidFreeTime/getAlllistFreeTime"
            create-url="/kidFreeTime/save"
            delete-url="/kidFreeTime/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="true"
            :accept-edit="false"
            :acceptView="false"
            @viewItem="viewItem"
        >
        </c-search-form>
        <!--            search-url="/kidClass/search/?sortField=status,classId&"-->
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/babiPro/TeacherFreeTimeCreate";
import {classIsActive, dateteachingBabiPro, levelBabiPro} from "@/constants/cateContants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Lịch đăng kí dạy của giáo viên",
      formCreateName: "Thêm mới lịch đăng kí dạy của giáo viên",
      category: null,
      lastSearchValues: {},
      visibleCreateDialog: false,
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'teacherId',
          text: 'Tên giáo viên',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "teacherId",
          items: [],
          itemText: "nameTeacher",
          itemValue: "id"
        },
        {
          value: 'programTimeId',
          text: 'Khung thời gian',
          width: "10%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "programTimeId",
          items: [],
          itemText: "programTimeName",
          itemValue: "programTimeId"
        },
        {
          value: "dayTime",
          text: 'Ngày có thể dạy',
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "dayTime",
          items: cateContants.dateteachingBabiPro,
          itemText: "text",
          itemValue: "value",
          width: "10%",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "8%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programTimeId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "teacherId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lịch đăng kí dạy Babi Pro';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lịch đăng kí dạy Babi Pro';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/classPro/view/' + item.classIdPro, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
